import { Inject } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

const domSanitizer: DomSanitizer = Inject(DomSanitizer);

export function sanitizeHtml(html: string): SafeHtml {
    return domSanitizer.bypassSecurityTrustHtml(html);
  }